'use client'

import { Modal } from '@wiggui/ds/Modal'
import { Button } from '@wiggui/ds/Button'
import { Text } from '@wiggui/ds/Text'
import { useModalRetrieveProperty } from './hooks/useModalRetrieveProperty'

export const ModalRetrieveProperty = () => {
  const { modalRetrieveProperty, onClose, handleRetrieveProperty, isLoading } =
    useModalRetrieveProperty()

  if (!modalRetrieveProperty?.isOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={onClose}
      isOpen={modalRetrieveProperty?.isOpen}
    >
      <Modal.Header
        title="Recuperar propiedad"
        isShowCloseButton
        isShowDivider
      />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-start justify-center">
        <>
          <Text className="text-primary text-body-m w-full" align="left">
            La propiedad se moverá a la sección{' '}
            <b>&quot;Mis propiedades&quot;</b>con el estatus de{' '}
            <b>&quot;Archivada&quot;</b>. Podrá permanecer archivada por tiempo
            indefinido o ser publicada nuevamente desde la sección{' '}
            <b>&quot;Mis propiedades&quot;</b>.
          </Text>
        </>
      </Modal.Body>
      <Modal.Footer
        className="w-full py-[9px] px-6 flex flex-row gap-2 items-center justify-center"
        isShowDivider
      >
        <Button variant="terciary" fullWidth onClick={onClose}>
          Cancelar
        </Button>
        <Button
          variant="secondary"
          isLoading={isLoading}
          fullWidth
          onClick={handleRetrieveProperty}
        >
          Recuperar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
